<template>
  <div class="GeneralCustomer">
    <div class="ContainerBtnRegister">
      <div class="pageHeading">
        <b-button class="btnNewInspect" @click="handleModals('inspect')">
          <b-icon-plus
            scale="1.5"
            style="
              width: 30px;
              background: #006458;
              height: 30px;
              color: white;
              border-radius: 3px;
            "
          ></b-icon-plus>
          <span style="width: 170px">Nova visita</span>
        </b-button>
        <!-- <span class="headingIcon"
          ><img class="chart-title-icon" :src="Corn"
        /></span>
        <div>
          <h1 style="font-size: 20px;">Visitas técnicas</h1>
          <p>
            Agenda, inspeções de campo e acompanhamento agronômico em um só
            lugar.
          </p>
        </div> -->
      </div>
      <div class="headerActions">
        <div class="switchContainer">
          <button
            v-for="option in viewOptions"
            :key="option.value"
            type="button"
            :class="['viewOption', { active: viewMode === option.value }]"
            :aria-label="option.label"
            :aria-pressed="viewMode === option.value"
            v-b-tooltip.hover.top="option.label"
            @click="viewMode = option.value"
          >
            <b-icon :icon="option.icon" />
            <span>{{ option.shortLabel }}</span>
          </button>
        </div>
      </div>
    </div>
    <div v-if="viewMode === 'list'">
      <div class="ContainerSearchInput">
        <div class="textRegister">
          <span>Visitas registradas</span>
        </div>
        <div class="searchInput" style="height: 100%">
          <div class="lineSearch">
            <button class="btnPeriod" size="sm">
              <b-icon-calendar3 /> Período
            </button>
            <div class="dateInput">
              <input
                type="date"
                id="dateStart"
                v-model="startDate"
                style="padding: 0.25rem 0.25rem 0.25rem 0.5rem; width: 130px"
                @change="read()"
              />
              <input
                type="date"
                id="dateEnd"
                v-model="endDate"
                style="padding: 0.25rem 1rem 0.25rem 0.25rem; width: 140px"
                @change="read()"
              />
            </div>
          </div>
          <div style="display: flex">
            <b-form-select
              v-if="showFilterTypes"
              id="filterType"
              class="searchFilterTypes"
              size="sm"
              value-field="value"
              text-field="text"
              v-model="filterType"
              :options="filterTypes"
            ></b-form-select>

            <b-form-select
              class="searchFilter"
              :style="
                showFilterTypes &&
                `border-left: none !important; border-radius: 0 0 0 0`
              "
              size="sm"
              value-field="value"
              text-field="text"
              v-model="type"
              :options="filterCombobox"
              @change="handleShowFilterTypes"
            ></b-form-select>

            <b-input
              size="sm"
              placeholder="Buscar visita..."
              v-model="textPesquisa"
              class="inputSearch"
              @keyup.enter="read(page)"
            ></b-input>

            <b-button size="sm" @click="read(page)" class="searchBtn">
              <b-icon-search></b-icon-search>
            </b-button>
            <div class="searchInputAll">
              <button class="searchAll" @click="resetAndRead">Limpar</button>
            </div>
          </div>
        </div>
      </div>
      <div class="ContentTable" v-if="inspecoes.length > 0">
        <div class="headerTable">
          <div class="celTable" style="width: 3%; text-align: center">Nº</div>
          <div class="celTable" style="width: 7%">Data</div>
          <div class="celTable" style="width: 5%">Horário</div>
          <div class="celTable" style="width: 22%">Produtor</div>
          <div class="celTable" style="width: 20%">Resp.Técnico</div>
          <div class="celTable" style="width: 10%">Status</div>
          <div class="celTable" style="width: 15%">Local</div>
          <div class="celTable" style="width: 10%">Cultura</div>
          <div class="celTableActions">Ações</div>
        </div>
        <div
          v-for="inspecao in inspecoes"
          :key="inspecao.id"
          @click="edit(inspecao)"
          :class="`rowCLient ${handleTableBorderColor(inspecao.status)}`"
        >
          <div
            class="celTable"
            style="
              width: 2%;
              justify-content: center;
              align-items: center;
              text-align: center;
            "
          >
            <span
              style="
                width: 100%;
                font-weight: bold;
                color: #006256;
                font-size: 13px;
              "
            >
              {{ inspecao.numero || 0 }}
            </span>
          </div>
          <div class="celTable" style="width: 7%">
            <span class="textEllipsis">
              {{ formatDate(inspecao.data || inspecao.date) }}
            </span>
          </div>
          <div class="celTable" style="width: 5%">
            <span class="textEllipsis">
              {{ formatHour(inspecao.hora || inspecao.startTime) }}
            </span>
          </div>
          <div class="celTable" style="width: 22%">
            <span class="textEllipsis">
              <strong>{{
                inspecao.cliente || inspecao.customerName || "Não informado"
              }}</strong>
            </span>
          </div>
          <div class="celTable" style="width: 20%">
            <span class="textEllipsis">
              <span class="secondaryLine"
                ><b-icon-person />
                {{ inspecao.professionalName || "Não informado" }}
              </span>
            </span>
          </div>
          <div class="celTable" style="width: 10%">
            <span
              class="textEllipsis"
              style="color: rgb(0, 81, 169); font-weight: 600"
            >
              <span
                class="statusBadge"
                >{{ inspecao.status }}</span
              ></span
            >
          </div>

          <div class="celTable" style="width: 15%">
            <span class="textEllipsis">
              <span class="secondaryLine"
                ><b-icon-geo-alt />
                {{
                  inspecao.propriedade ||
                  inspecao.property ||
                  inspecao.propertyName ||
                  "Não informada"
                }}</span
              >
            </span>
          </div>

          <div class="celTable" style="width: 10%">
            <span class="textEllipsis" style="font-weight: 600">
              {{
                inspecao.cultura ||
                inspecao.crop ||
                inspecao.cultureName ||
                "--"
              }}
              <small v-if="inspecao.diagnosisCount > 1">
                · {{ inspecao.diagnosisCount }} áreas
              </small></span
            >
          </div>
          <div class="celTableActions">
            <div class="btnActions">
              <b-dropdown
                id="dropdown-1"
                class="btnActions1"
                variant="none"
                size="sm"
              >
                <template #button-content>
                  <b-icon-gear-fill class="contentActions"></b-icon-gear-fill>
                </template>

                <b-dropdown-item
                  v-if="!['Concluído', 'Cancelado'].includes(inspecao.status)"
                  :disabled="rowActionInProgress !== null"
                  @click.stop="cancelAttendance(inspecao)"
                >
                  {{
                    rowActionInProgress === `cancel-${inspecao.id}`
                      ? "Cancelando..."
                      : "Cancelar"
                  }}
                </b-dropdown-item>
                <b-dropdown-item @click.stop="printInspection(inspecao.id)">
                  Imprimir
                </b-dropdown-item>
                <b-dropdown-item @click.stop="cloneInspection(inspecao)">
                  Clonar inspeção
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="inspecao.status === 'Aberto'"
                  :disabled="rowActionInProgress !== null"
                  @click.stop="deleteInspection(inspecao.id)"
                >
                  {{
                    rowActionInProgress === `delete-${inspecao.id}`
                      ? "Excluindo..."
                      : "Excluir"
                  }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="defaultSearch">
        <span class="emptyIcon"><b-icon-search /></span
        ><strong>Nenhuma visita encontrada</strong
        ><small>Crie uma nova visita ou altere os filtros de pesquisa.</small>
      </div>
      <div class="setBtn">
        <button @click="previousPage" :disabled="page === 1" class="itemBtn">
          <b-icon-chevron-left></b-icon-chevron-left>
        </button>
        <button class="centerItemBtn">{{ page }}</button>
        <button
          @click="nextPage"
          :disabled="this.page * 9 >= this.dataLength"
          class="itemBtn"
        >
          <b-icon-chevron-right></b-icon-chevron-right>
        </button>
      </div>
    </div>
    <NewSchedule
      v-else-if="viewMode === 'agenda'"
      @open-inspection="openInspectionFromSchedule"
    />
    <InspectionDashboard v-else />
    <div :class="sizeModal">
      <div :class="modalContainer" v-if="colapseModal">
        <b-button class="closeModalRegister" @click="modalHeight"> X </b-button>
        <Inspect
          v-if="this.typeDocument.inspect"
          @close="modalHeight"
          @saved="handleInspectionSaved"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { DateTime } from "luxon";
import { mapMutations, mapState } from "vuex";
import Corn from "../../assets/corn.svg";
import Inspect from "./Inspect.vue";
import NewSchedule from "./NewSchedule.vue";
import InspectionDashboard from "./InspectionDashboard.vue";
import serviceInspection from "../../services/serviceInspection.js";
import { cloneInspectionAsDraft } from "./inspectionDiagnosis";
export default {
  name: "GeneralCustomer",
  components: {
    Inspect,
    NewSchedule,
    InspectionDashboard,
  },
  data() {
    return {
      Corn: Corn,
      viewMode: "list",
      viewOptions: [
        { value: "list", label: "Ver visitas", shortLabel: "Lista", icon: "grid" },
        { value: "agenda", label: "Ver agenda", shortLabel: "Agenda", icon: "calendar2-event" },
        { value: "dashboard", label: "Ver dashboard", shortLabel: "Dashboard", icon: "bar-chart-line" },
      ],
      textPesquisa: "",
      type: "",
      startDate: "",
      endDate: "",
      dataLength: 0,
      page: 1,
      filterTypes: [
        { value: "includes", text: "Contém" },
        { value: "start", text: "Inicia por" },
      ],
      filterType: "start",
      showFilterTypes: false,
      inspecoes: [],
      spinGeneral: false,
      rowActionInProgress: null,

      selectedDateForNewInspection: null,
      spinLoading: false,
      textToModalLoading: "",
      colapseModal: false,
      modalContainer: "contentModalDisable",
      filterCombobox: [
        { value: "", text: "Filtrar por..." },
        { value: "customerName", text: "Cliente" },
        { value: "professionalName", text: "Responsável Técnico" },
        { value: "propertyName", text: "Propriedade" },
        { value: "cultureName", text: "Cultura" },
        { value: "reason", text: "Motivo" },
      ],
    };
  },
  methods: {
    ...mapMutations([
      "ALTER_SIZE_MODAL_REGISTER",
      "ALTER_TYPE_REGISTER",
      "ALTER_TYPE_DOCUMENT",
      "SET_COLAPSE_REGISTER",
      "ALTER_MODAL_CONTAINER_REGISTER",
      "SET_DATA_SEARCH_FROM_INSPECT",
      "SET_HTML_TO_PRINT",
      "ALTER_SIZE_MODAL",
      "SET_DATA_SEARCH_FROM_BOX_FRONT",
      "SET_DATA_SEARCH_FROM_SALE",
    ]),

    initDates() {
      const now = DateTime.local();
      this.startDate = now.startOf("month").toISODate();
      this.endDate = now.endOf("month").toISODate();
    },

    resetModalStates() {
      this.SET_COLAPSE_REGISTER(false);
      this.SET_DATA_SEARCH_FROM_INSPECT({});
      this.ALTER_SIZE_MODAL_REGISTER("disable");
      this.ALTER_SIZE_MODAL("disable");
      this.ALTER_MODAL_CONTAINER_REGISTER("contentModalDisable");
    },

    handleShowFilterTypes() {
      const types = ["customerName", "professionalName"];
      if (types.includes(this.type)) {
        this.showFilterTypes = true;
        return;
      }
      this.showFilterTypes = false;
      this.filterType = "includes";
    },

    async read(targetPage = 1) {
      this.page = targetPage;
      this.spinGeneral = true;

      try {
        const data = await serviceInspection.findAll({
          dateFrom: this.startDate,
          dateTo: this.endDate,
          q: this.textPesquisa,
          type: this.type,
          filterType: this.filterType,
          page: this.page,
          limit: 9,
        });
        this.inspecoes = data.data || [];
        this.dataLength = data.total || 0;
      } catch (error) {
        this.inspecoes = [];
        this.$toast.open({
          message: "Não foi possível listar as visitas técnicas",
          type: "error",
        });
      } finally {
        this.spinGeneral = false;
      }
    },

    resetAndRead() {
      this.clearSearch();
      this.read(1);
    },

    nextPage() {
      this.read(this.page + 1);
    },

    previousPage() {
      if (this.page === 1) {
        return;
      } else {
        this.read(this.page - 1);
      }
    },

    clearSearch() {
      this.textPesquisa = "";
      this.type = "";
    },

    handleTableBorderColor(status) {
      const colors = {
        ["Em aberto"]: "borderOpen",
        ["Em Aberto"]: "borderOpen",
        ["Finalizado"]: "borderFinished",
        ["Vencido"]: "borderExpired",
        ["Aberto"]: "borderOpen",
        ["Em andamento"]: "borderOpen",
        ["Concluído"]: "borderFinished",
        ["Cancelado"]: "borderExpired",
      };

      return colors[status];
    },

    async edit(inspecao) {
      try {
        this.openModal(await serviceInspection.findById(inspecao.id));
      } catch (error) {
        this.$toast.open({
          message: "Não foi possível carregar a visita técnica",
          type: "error",
        });
      }
    },
    async startAttendance(inspecao) {
      try {
        if (inspecao.status !== "Em andamento") {
          await serviceInspection.updateStatus(inspecao.id, "Em andamento");
        }
        this.openModal(await serviceInspection.findById(inspecao.id));
      } catch (error) {
        this.$toast.open({
          message: "Não foi possível iniciar a visita técnica",
          type: "error",
        });
      }
    },
    async cancelAttendance(inspecao) {
      if (this.rowActionInProgress !== null) return;
      this.rowActionInProgress = `cancel-${inspecao.id}`;
      try {
        await serviceInspection.updateStatus(inspecao.id, "Cancelado");
        await this.read(this.page);
      } catch (error) {
        this.$toast.open({
          message: "Não foi possível cancelar a visita técnica",
          type: "error",
        });
      } finally {
        this.rowActionInProgress = null;
      }
    },
    unresolvedCount(inspecao) {
      if (inspecao.unresolvedCount !== undefined) {
        return inspecao.unresolvedCount;
      }
      return (inspecao.pendingActions || []).filter(
        ({ status }) => !["Resolvido", "Cancelado"].includes(status)
      ).length;
    },
    openModal(inspecaoData) {
      this.SET_DATA_SEARCH_FROM_INSPECT(inspecaoData);
      this.ALTER_TYPE_DOCUMENT("inspect");
      this.ALTER_TYPE_REGISTER("inspect");
      this.ALTER_SIZE_MODAL_REGISTER("ModalGeneral");
      this.SET_COLAPSE_REGISTER(true);
      if (!this.colapseModal) this.modalHeight();
    },
    async openInspectionFromSchedule(schedule) {
      try {
        const inspection = await serviceInspection.findById(schedule.id);
        this.SET_DATA_SEARCH_FROM_INSPECT(inspection);
        this.handleModals("inspect");
      } catch (error) {
        this.$toast.open({
          message: "Não foi possível abrir a visita agendada",
          type: "error",
        });
      }
    },
    async cloneInspection(inspecao) {
      try {
        const source = await serviceInspection.findById(inspecao.id);
        this.openModal(cloneInspectionAsDraft(source));
        this.$toast.open({
          message: "Cópia preparada. Revise os dados e salve a nova inspeção.",
          type: "info",
        });
      } catch (error) {
        this.$toast.open({
          message: "Não foi possível preparar a cópia da visita técnica",
          type: "error",
        });
      }
    },

    async handleInspectionSaved() {
      await this.read(this.page);
    },

    handleModals(name) {
      this.ALTER_TYPE_DOCUMENT(name);
      this.modalHeight();
    },
    async modalHeight() {
      this.colapseModal = !this.colapseModal;
      this.colapseModal
        ? this.ALTER_SIZE_MODAL("ModalGeneral")
        : this.ALTER_SIZE_MODAL("disable");
      this.modalContainer = this.modalContainer
        ? "modalContainer"
        : "contentModalDisable";

      if (!this.colapseModal && this.sizeModal === "disable") {
        this.SET_DATA_SEARCH_FROM_INSPECT({});
        this.selectedDateForNewInspection = null;
      }

      // if (!nextCollapse) {
      //   this.SET_DATA_SEARCH_FROM_INSPECT({});
      // }
    },
    formatDate(dateStr) {
      if (!dateStr) return "--/--/----";
      return DateTime.fromISO(dateStr).toFormat("dd/MM/yyyy");
    },

    formatHour(timeStr) {
      if (!timeStr) return "00:00";
      return timeStr.substring(0, 5);
    },

    async deleteInspection(id) {
      if (this.rowActionInProgress !== null) return;
      this.rowActionInProgress = `delete-${id}`;
      try {
        await serviceInspection.delete(id);
        await this.read(this.page);
        this.$toast.open({
          message: "Visita técnica excluída com sucesso",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message: "Não foi possível excluir a visita técnica",
          type: "error",
        });
      } finally {
        this.rowActionInProgress = null;
      }
    },
    printInspection(id) {
      serviceInspection.print(id);
    },
  },
  computed: {
    ...mapState({
      sizeModal: (state) => state.sizeModal,
      typeDocument: (state) => state.typeDocument,
      sizeModalRegister: (state) => state.sizeModalRegister,
      typeRegister: (state) => state.typeRegister,
      colapseRegister: (state) => state.colapseRegister,
      dataSearchConsultant: (state) => state.dataSearchConsultant,
      isSearchRegisters: (state) => state.isSearchRegisters,
      dataConfig: (state) => state.dataConfig,
    }),
  },
  async created() {
    this.initDates();
    this.read(1);
    this.resetModalStates();
  },
  beforeDestroy() {
    this.SET_DATA_SEARCH_FROM_INSPECT({});
  },
  watch: {
    isSearchRegisters() {
      this.read(this.page);
    },
  },
};
</script>
<style scoped>
.GeneralCustomer {
  display: flex;
  flex-direction: column;
  margin-left: 90px;
  width: calc(100% - 120px);
  height: 100vh;
  font-family: "Poppins", sans-serif;
  background-color: #f8fafc;
  padding: 20px;
}

.ContainerBtnRegister {
  display: flex;
  margin-top: 45px;
  margin-bottom: 5px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 30px;
  padding: 0 0 10px 0;
  border-bottom: 1px solid rgb(227, 227, 227);
}

.BtnRegister {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #006256;
  color: #ffffff;
  border: none;
  padding: 8px 20px 8px 8px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 13px;
  transition: all 0.2s ease-in-out;
}
.btnNewInspect {
  width: 200px;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #e3ebe2;
  height: 30px;
  border-radius: 3px;
  font-size: 13px;
  margin: 0;
  color: #006458;
  border: 1px solid #cfe5e3;
}

.btnNewInspect:hover {
  background: whitesmoke;
  color: #006458;
  border: 1px solid #006458;
  box-shadow: none;
}
.btnNewInspect:focus {
  background: whitesmoke;
  color: #006458;
  border: 1px solid #006458;
  box-shadow: none;
}
.customDateInput {
  padding: 0.25rem 0.25rem 0.25rem 0.5rem;
  cursor: pointer;
  border-left: none;
  width: 110px;
  border-radius: 0 5px 5px 0;
  border: 1px solid rgb(195, 193, 193);
  height: 30px;
}

.customDateInput.marginEnd {
  padding: 0.25rem;
  margin-right: 20px;
  border-radius: 5px;
}

.borderFinished {
  border-left: solid 10px green;
}

.borderOpen {
  border-left: solid 10px rgb(0, 81, 169);
}

.borderExpired {
  border-left: solid 10px rgb(110, 35, 35);
}

.ModalGeneral {
  position: fixed !important;
  z-index: 900;
  top: 53px;
  left: 61px;
  height: calc(100% - 53px);
  max-height: calc(100% - 53px);
  overflow: auto;
  width: calc(100% - 62px);
  background: #ffff;
  transition: all 0.7s ease-in-out;
}
.disable {
  position: absolute;
  width: calc(100% - 62px);
  height: 0;
  left: 61px;
  top: 100vh;
  background: #b0b0b000;
  visibility: hidden;
  transition: all 0.7s ease-in-out;
}

.closeModalRegister {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 0;
  z-index: 900;
  font-size: 18px;
  height: 30px;
  background: white;
  border: none;
  color: rgb(6, 6, 6);
}
.chart-title-icon {
  width: 20px;
  height: 20px;
}
.closeModalRegister:hover {
  background: whitesmoke;
  color: red;
}

.closeModalRegister:focus {
  background: red;
  border: none;
  box-shadow: none;
}

.modalContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.ContentTable {
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 10px;
  gap: 5px;
  width: 100%;
  min-height: 60vh;
  max-width: 100%;
  background: #ebebeb;
  margin-top: 20px;
  border-radius: 10px;
  margin-bottom: 10px;
}
.headerTable {
  border: 1px solid #006256;
  border-radius: 5px 5px 0 0;
  width: 100%;
  display: grid;
  grid-template-columns: 3fr 7fr 5fr 22fr 20fr 10fr 15fr 10fr 5fr;
  align-items: center;
  height: 30px;
  gap: 10px;
  background: #006256;
  color: whitesmoke !important;
  font-weight: bold;
  font-size: 12px;
}
.rowCLient {
  width: 100%;
  display: grid;
  grid-template-columns: 3fr 7fr 5fr 22fr 20fr 10fr 15fr 10fr 5fr;
  align-items: center;
  background: #ffffff;
  border: 1px solid rgb(226, 226, 226);
  border-radius: 2px;
  text-align: center;
  height: 40px;
  padding: 0;
  gap: 10px;
  cursor: context-menu;
  color: #313131;
  font-size: 12px;
}

.rowCLient:hover {
  background: rgb(242, 242, 242);
  cursor: pointer;
}
.celTableActions {
  display: flex;
  gap: 5px;
  width: 5%;
  text-align: center;
  justify-content: center;
  align-items: center;
}
.textEllipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.celTable {
  display: flex;
  flex-direction: column;
  text-align: start;
}

.headerTable > .celTable,
.rowCLient > .celTable,
.headerTable > .celTableActions,
.rowCLient > .celTableActions {
  width: 100% !important;
  min-width: 0;
}

.celInfos {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.3rem;
  border: solid 1px #cbcbcb;
  border-radius: 5px;
  height: 25px;
  width: 70px;
  font-size: 12px !important;
  color: #403b74;
  background: #ececec;
  margin: 0;
}

.btnActions {
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btnActions1:hover {
  background: rgb(215, 213, 213);
  color: white;
}

.btnActions1 {
  border-radius: 10px;
}

.dropdown-menu {
  font-size: 12px;
  min-width: 5rem !important;
  width: 5rem !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  color: red;
  background: red;
  text-align: center;
  list-style: none;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu li {
  font-size: 12px;
  width: 100% !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  display: flex;
  text-align: center;
  list-style: none;
  border: none;
}

.contentActions {
  color: rgb(82, 78, 78);
}

.searchFilter {
  width: 100px;
  border-right: none !important;
  border-radius: 5px 0 0 5px !important;
  height: 30px;
  font-size: 11px !important;
  text-align: center;
}

.searchFilterTypes {
  width: 150px;
  border-right: none;
  height: 30px;
  font-size: 11px;
  text-align: center;
}

.ContainerSearchInput {
  display: flex;
  align-items: center;
  height: 37px;
  width: 100%;
  padding-right: 20px;
  justify-content: space-between;
}

.textRegister span {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.textRegister {
  width: 25%;
  display: flex;
}

.btnPeriod {
  border-radius: 5px 0px 0px 5px;
  border: 1px solid rgb(235 235 235);
  padding: 0 10px;
  height: 30px;
  font-size: 11px;
  cursor: context-menu;
}

.dateInput {
  display: flex;
  gap: 10px;
}
input {
  border: 1px solid #e3e0e0;
  border-radius: 5px;
  height: 30px;
  font-size: 13px !important;
}
input:focus {
  box-shadow: none;
  border: 1px solid #e3e0e0;
}
.input {
  font-size: 12px !important;
  width: 100%;
}

.input:focus ~ label,
input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
  font-weight: 600;
}
.form-control:focus {
  background-color: #ffffff00;
  box-shadow: none !important;
}

.form-control {
  border-radius: 0 !important;
}
.form-control-sm {
  padding: 0.25rem 1.5rem;
  height: 30px;
  width: 180px;
}
.searchInput {
  display: flex;
  align-items: center;
  gap: 15px;
  margin: 5px 0px 5px 0px;
}

.searchInputPerson {
  display: flex;
  padding-right: 4%;
  align-items: center;
}

.lineSearch {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding-left: 10px;
}

.searchInputAll {
  display: flex;
  height: 30px;
}

.inputSearch {
  width: 200px;
  font-size: 12px !important;
}

.searchAll {
  justify-content: center;
  color: #3a4750;
  font-size: 12px;
  padding: 5px 10px;
  font-weight: bold;
  border: solid 1px #e3e0e0;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.searchAll:hover {
  background: rgb(205, 205, 205);
}

.searchBtn {
  right: 10px;
  height: 30px;
  position: relative;
  background: whitesmoke;
  color: black;
  border-radius: 0 5px 5px 0;
  border-left: none;
  border-color: #c3c1c1;
}

.defaultSearch {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 55vh;
  background: #ebebeb;
  margin-top: 20px;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}

.defaultSearch span {
  font-size: 1rem;
  font-weight: bold;
  color: gray;
}

.setBtn {
  display: flex;
  flex-direction: row;
  margin: 0 1rem 1rem 0;
  gap: 10px;
  justify-content: flex-end;
}

.itemBtn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #3a4750;
  background: transparent;
  cursor: pointer;
}

.itemBtn:hover:not(:disabled) {
  background: #3a4750;
  color: whitesmoke;
}

.itemBtn:disabled {
  opacity: 0;
  cursor: default;
}

.centerItemBtn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #1b3159;
  background: transparent;
  cursor: auto;
}

.switchContainer {
  display: flex;
  align-items: center;
  gap: 3px;
  padding: 3px;
  background: #e2f0e3;
  border: 1px solid #d3e5df;
  border-radius: 7px;
}

.viewOption {
  height: 31px;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 0 9px;
  border: 0;
  border-radius: 5px;
  background: transparent;
  color: #55736c;
  font-size: 10px;
  font-weight: 600;
  transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.viewOption:hover,
.viewOption.active {
  background: white;
  color: #006256;
  box-shadow: 0 1px 3px rgba(0, 65, 55, 0.16);
}

.GeneralCustomer {
  --agro: #006256;
  --agro-dark: #004d43;
  --surface: #fff;
  --page: #f4f7f6;
  --border: #dde7e4;
  --text: #263238;
  --muted: #6b7c78;
  background: var(--page);
  padding: 28px 32px;
}

.pageHeading,
.headerActions,
.visitIdentity {
  display: flex;
  align-items: center;
  gap: 12px;
}
.pageHeading h1 {
  font-size: 22px;
  line-height: 1.2;
  margin: 0;
  color: var(--text);
  font-weight: 700;
}
.pageHeading p {
  font-size: 12px;
  color: var(--muted);
  margin: 4px 0 0;
}
.headingIcon,
.visitIcon,
.emptyIcon {
  display: grid;
  place-items: center;
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background: #e5f3f0;
  color: var(--agro);
  font-size: 20px;
}
.BtnRegister {
  height: 38px;
  padding: 0 16px;
  gap: 8px;
  box-shadow: 0 4px 10px rgba(0, 98, 86, 0.16);
}
.ContainerSearchInput {
  height: auto;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 3px 9px;
  margin-bottom: 2px;
}
.textRegister span {
  font-size: 14px;
  color: var(--text);
}
.searchInput {
  gap: 12px !important;
}
.dateInput {
  gap: 6px;
}

.visitIdentity {
  min-width: 105px;
}
.visitIdentity > span:last-child {
  display: flex;
  flex-direction: column;
}
.visitIdentity small,
.celTable small {
  font-size: 11px;
  color: #82918e;
  font-weight: 700;
}
.visitIdentity strong {
  font-size: 12px;
}

.secondaryLine {
  color: #6b7c78;
  font-size: 11px;
}
.statusBadge {
  display: inline-flex;
  width: max-content;
  padding: 3px 9px;
  border-radius: 999px;
  font-size: 10px;
  background: #e5f3f0;
  color: var(--agro) !important;
}
.statusBadge.borderExpired {
  background: #feeceb;
  color: #b42318 !important;
}
.statusBadge.borderFinished {
  background: #e9f7ee;
  color: #18794e !important;
}
.celInfos {
  width: auto;
  min-width: 78px;
  height: 32px;
  background: var(--agro);
  color: white;
  border: 0;
  padding: 0 12px !important;
}
.celInfos:hover {
  background: var(--agro-dark);
}
.defaultSearch {
  height: 45vh;
  background: var(--surface);
  border: 1px dashed #c4d5d0;
  gap: 7px;
}
.defaultSearch .emptyIcon {
  font-size: 23px;
}
.defaultSearch strong {
  color: var(--text);
}
.defaultSearch small {
  color: var(--muted);
}
.searchBtn {
  background: var(--agro);
  color: white;
  border-color: var(--agro);
}
@media (max-width: 1100px) {
  .ContainerSearchInput {
    align-items: flex-start;
    gap: 12px;
  }
  .searchInput {
    flex-wrap: wrap;
  }
  .rowCLient {
    flex-wrap: wrap;
  }
  .visitIdentity {
    width: 100%;
  }
  .GeneralCustomer {
    margin-left: 65px;
    width: calc(100% - 65px);
  }
}
@media (max-width: 700px) {
  .GeneralCustomer {
    padding: 18px;
    margin-left: 60px;
    width: calc(100% - 60px);
  }
  .ContainerBtnRegister,
  .ContainerSearchInput {
    flex-direction: column;
    align-items: stretch;
  }
  .headerActions {
    justify-content: space-between;
  }
  .viewOption span {
    display: none;
  }
  .lineSearch {
    padding-left: 0;
  }
  .dateInput {
    flex-wrap: wrap;
  }
}
</style>
